
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'About', href: '/about' },
    { name: 'Sell Your Business', href: '/sell-your-business' },
    { name: 'Contact', href: '/contact' },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="bg-[#F8F9FA] shadow-sm sticky top-0 z-50">
      <nav className="mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-2">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <img 
              src="https://static.readdy.ai/image/2a3205e7e8ef8b3d476f9ddb9e8c5218/54cee621a47cdd3d88714c3544241b83.png" 
              alt="Legacy Business Acquisitions LLC" 
              className="h-52 w-52 object-contain"
            />
            <div className="flex flex-col">
              <span className="font-playfair text-5xl font-bold text-navy leading-tight">LEGACY</span>
              <span className="text-xl font-medium text-gray-600">Business Acquisitions</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`text-sm font-medium transition-colors duration-200 ${
                  isActive(item.href)
                    ? 'text-[#C9A227] border-b-2 border-[#C9A227] pb-1'
                    : 'text-gray-700 hover:text-[#C9A227]'
                }`}
              >
                {item.name}
              </Link>
            ))}
            <button 
              onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
              className="btn-primary"
            >
              Schedule Call
            </button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-[#C9A227] p-2"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`text-sm font-medium transition-colors duration-200 ${
                    isActive(item.href) ? 'text-[#C9A227]' : 'text-gray-700'
                  }`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
              <button 
                onClick={() => {
                  document.querySelector('#vapi-widget-floating-button')?.click();
                  setIsMenuOpen(false);
                }}
                className="btn-primary w-fit"
              >
                Schedule Call
              </button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
